






























































































































































































import {Component, Prop, Watch} from "vue-property-decorator";
import {ScrollButton} from "wings-ui-components";
import { Getter, Action } from "vuex-class";
import { IncomingTariffsItem } from "@/store/tarification/incoming_tariffs/types";
import BaseItemsPage from "../BaseItemsPage";
import { MsgTransports } from "@/store/types";
import IncomingTariffsFilter from "@/components/Tarification/IncomingTariffsFilter.vue";
import draggable from 'vuedraggable'
import {cloneDeep} from "lodash";

@Component({ components: { draggable, IncomingTariffsFilter, ScrollButton } })
export default class IncomingTariffs extends BaseItemsPage<IncomingTariffsItem> {
  @Prop() transport!: MsgTransports;

  @Action("saveIncomingTariffPriority") savePriority: any;
  @Getter("incomingTariffs") responseItems!: IncomingTariffsItem[];

  is_show_filter = false;
  tableFields = this.tableFieldsDefault;
  modelDragon: IncomingTariffsItem[] = [];

  get tableFieldsDefault() {
    return [
      "id",
      "service_number",
      "service_provider",
      "regexp",
      "partner",
      "broker_account"
    ];
  }

  getData(): IncomingTariffsItem[] {
    this.modelDragon = cloneDeep(this.responseItems);
    return this.responseItems;
  }

  @Watch('modelDragon', {deep: true})
  async onModelChange(val: any, new_val: any) {
    let ids = val.map((e: any) => Number(e.id));
    if (ids.length && new_val.length) {
      const priorities = { mo_routing_rules: ids };
      await this.savePriority({priorities: priorities, transport: this.transport});
    }
  }
}
